// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueRouter from 'vue-router';
import * as localize from '@/localize.js';
import 'libs/startup.js';
import Dialogs from 'components/Dialogs/Dialogs.vue';
import Toaster from 'components/Dialogs/Toaster.vue';
import ToastPlugin from '@/plugins/toaster.js';
import '@/styles/settings.scss';
import store from '@/store/index';
import bootstrapHelper from '@/libs/bootstraphelper';
import * as AdminSystemTables from '@/pages/components/admin/systemtables/defaultImplementations';
import { getLang, loadLanguageAsync } from '@/localizehelpers.js';

Vue.use(VueRouter);
// Vue.use(ToastPlugin, { toaster: self.$refs.toaster, dialogs: self.$refs.dialogs });

const WorkingTickets = () => import('@/pages/components/WorkingTicketViews.vue');
const MyBaskets = () => import('@/pages/components/MyBaskets.vue');
const MoveBaskets = () => import('@/pages/components/MoveBaskets.vue');
const OrderBaskets = () => import('@/pages/components/OrderBaskets.vue');
const EInvoices = () => import('@/pages/components/EInvoices.vue');
const ObjectCodes = () => import('@/pages/components/ObjectCodes.vue');
const Objects = () => import('@/pages/components/Objects.vue');
const ObjectLocationMISchedules = () => import('@/pages/components/ObjectLocationMISchedules.vue');
const ObjectLocations = () => import('@/pages/components/ObjectLocations.vue');
const ObjectMIs = () => import('@/pages/components/ObjectMIs.vue');
const Orders = () => import('@/pages/components/Orders.vue');
const WorkFlowViews = () => import('@/pages/components/WorkFlowViews.vue');
const ProcessedMoveBaskets = () => import('@/pages/components/ProcessedMoveBaskets.vue');
const PickLists = () => import('@/pages/components/PickLists.vue');
const PackLists = () => import('@/pages/components/PackLists.vue');
const Persons = () => import('@/pages/components/Persons.vue');
const Projects = () => import('@/pages/components/Projects.vue');
const Relations = () => import('@/pages/components/Relations.vue');
const Contracts = () => import('@/pages/components/RelationContracts.vue');
const MIs = () => import('@/pages/components/MIs.vue');
const Locations = () => import('@/pages/components/Locations.vue');
const Products = () => import('@/pages/components/Articles.vue');
const Invoices = () => import('@/pages/components/Invoices.vue');
const ObjectTypes = () => import('@/pages/components/ObjectTypes.vue');
const ReturnEntry = () => import('@/pages/components/ReturnEntry.vue');
const Object00Locations = () => import('@/pages/components/Object00Locations.vue');
const ProvisioningPage = () => import('@/pages/app/SingleSignOn/MemberShip/Provisioning.vue');
const ObjectLocationLog = () => import('@/pages/components/ObjectLocationLog.vue');
const Scheduler = () => import('@/pages/components/Scheduler.vue');
const SessionUserLogs = () => import('@/pages/components/SessionUserLogs.vue');
const OrderLines = () => import('@/pages/components/Orderlines.vue');
const Teams = () => import('@/pages/components/Teams.vue');
const InvoiceLines = () => import('@/pages/components/InvoiceLines.vue');
const PurchaseOrderLines = () => import('@/pages/components/PurchaseOrderLines.vue');
const BudgetCodes = () => import('@/pages/components/BudgetCodes.vue');
const Warehouses = () => import('@/pages/components/Warehouses.vue');
const Users = () => import('@/pages/components/Users.vue');
const IdentityProviders = () => import('@/pages/components/IdentityProviders.vue');
const PurchaseOrders = () => import('@/pages/components/PurchaseOrders.vue');
const ReturnEntryLines = () => import('@/pages/components/ReturnEntryLines.vue');
const ObjectMIAutoResponderSettings = () => import('@/pages/components/ObjectMIAutoResponderSettings.vue');
const PersonUserAutoResponderSettings = () => import('@/pages/components/PersonUserAutoResponderSettings.vue');
const ObjectObjectProperties = () => import('@/pages/components/ObjectObjectProperties.vue');
const PurchaseOrderSystemSetting = () => import('@/pages/app/PurchaseOrderSystemSetting/content/Detail.vue');
const OrderTemplates = () => import('@/pages/components/OrderTemplates.vue');
const DownloadRequests = () => import('@/pages/components/DownloadRequests.vue');
const LocationTypes = () => import('@/pages/components/LocationTypes.vue');
const MIPlans = () => import('@/pages/components/MIPlans.vue');
import License from '@/pages/components/License.vue';
const ReportDefinitions = () => import('@/pages/components/ReportDefinitions.vue');
const ApiClients = () => import('@/pages/components/ApiClients/App.vue');
const SystemSetting = () => import('@/pages/app/SystemSetting/content/Detail.vue');
const SystemFinancialSetting = () => import('@/pages/app/SystemFinancialSetting/content/Detail.vue');
const ContractSystemSetting = () => import('@/pages/app/ContractSystemSetting/content/Detail.vue');
const FieldClientMessageSystemSetting = () => import('@/pages/app/FieldClientMessageSystemSetting/content/Detail.vue');
const MobileMessages = () => import('@/pages/components/MobileMessages.vue');
const MoveBasketAutoResponderSettings = () => import('@/pages/components/MoveBasketAutoResponderSettings.vue');
const MailServerSetting = () => import('@/pages/app/SystemTasks/content/MailserverDetail.vue');
const DatabaseSetting = () => import('@/pages/app/SystemTasks/content/DatabaseSettingsDetail.vue');
const RecalculateWorkflowPosition = () => import('@/pages/app/SystemTasks/content/RecalculateWorkflowPositions.vue');
const WorkableDays = () => import('@/pages/components/WorkableDays.vue');
const PriceLists = () => import('@/pages/components/PriceLists.vue');
const Journals = () => import('@/pages/components/Journals.vue');
const Administrations = () => import('@/pages/components/Administrations.vue');
const ContractTypes = () => import('@/pages/components/ContractTypes.vue');
const ContractAutoResponderSettings = () => import('@/pages/components/ContractAutoResponderSettings.vue');
const NewUserRequestAutoResponseSettings = () => import('@/pages/components/NewUserRequestAutoResponderSettings.vue');
const PurchaseOrderAutoResponseSettings = () => import('@/pages/components/PurchaseOrderAutoResponseSettings.vue');
const InvoiceAutoResponseSettings = () => import('@/pages/components/InvoiceAutoResponseSettings.vue');
const PurchaseInvoiceAutoResponseSettings = () => import('@/pages/components/PurchaseInvoiceAutoResponseSettings.vue');
const FixedAssetGroups = () => import('@/pages/components/FixedAssetGroups.vue');
const PurchaseInvoices = () => import('@/pages/components/PurchaseInvoices.vue');
const BookYears = () => import('@/pages/components/BookYears.vue');
const RegionOrderCosts = () => import('@/pages/components/OrderCosts.vue');
const RegionTransportCosts = () => import('@/pages/components/TransportCosts.vue');
const ProductStockPurchase = () => import('@/pages/components/ProductStockPurchase.vue');
const ObjectSystemSetting = () => import('@/pages/app/ObjectSystemSetting/Detail.vue');
const RecurringWorkFlow = () => import('@/pages/components/RecurringWorkFlows.vue');
const WorkflowTemplates = () => import('@/pages/components/WorkflowTemplates.vue');
const LocationAutoResponderSettings = () => import('@/pages/components/LocationAutoResponderSettings.vue');
const LocationStatusLogs = () => import('@/pages/components/LocationStatusLogs.vue');
const WorkingTicketAutoResponderSettings = () => import('@/pages/components/WorkingTicketAutoResponderSettings.vue');
const CapacityPlanning = () => import('@/pages/components/CapacityPlanning.vue');
const EmailTemplates = () => import('@/pages/components/EmailTemplates.vue');
const StockRevaluations = () => import('@/pages/components/StockRevaluations.vue');
const PersonCompetences = () => import('@/pages/components/PersonCompetences.vue');
const ObjectMeterSchedules = () => import('@/pages/components/ObjectMeterSchedules.vue');
const Meterreadings = () => import('@/pages/components/Meterreadings.vue');
const WorkFlowGroups = () => import('@/pages/components/WorkFlowGroups.vue');
const Countries = () => import('@/pages/components/Countries.vue');
const Logs = () => import('@/pages/components/Logs.vue');
const Lists = () => import('@/pages/components/Lists.vue');
const WorkFlowAutoResponderSettings = () => import('@/pages/components/WorkFlowAutoResponderSettings.vue');
const FormConfigurations = () => import('@/pages/components/FormConfigurations.vue');
const Brands = () => import('@/pages/components/Brands.vue');
const Quantities = () => import('@/pages/components/Quantities.vue');
const InspectionNorms = () => import('@/pages/components/InspectionNorms.vue');
const VatCodes = () => import('@/pages/components/VatCodes.vue');
const Reasons = () => import('@/pages/components/Reasons.vue');
const ReturnRequestAutoResponderSettings = () => import('@/pages/components/ReturnRequestAutoResponderSettings.vue');
const ProductDetail = () => import('@/pages/components/ProductDetail.vue');
const WorkFlowServiceLevels = () => import('@/pages/components/WorkFlowServiceLevels.vue');
const FormDetail = () => import('@/pages/app/FormDetail/App.vue');
const ReturnRequests = () => import('@/pages/components/ReturnRequests.vue');
const LogSettings = () => import('@/pages/components/LogSettings.vue');
const Versions = () => import('@/pages/components/Versions.vue');
const WorkFlowPriorities = () => import('@/pages/components/WorkFlowPriorities.vue');
const ReturnRequestsFrontOffice = () => import('@/pages/components/FrontOffice/ReturnRequestsFO.vue');
const BasketDetail = () => import('@/pages/components/BasketDetail.vue');
const OrderBasketDetail = () => import('@/pages/components/OrderBasketDetail.vue');
const MoveBasketDetail = () => import('@/pages/app/MoveBasket/Detail.vue');
const ProductSystemSetting = () => import('@/pages/app/ProductsSystemSetting/content/Detail.vue');
const OrderSystemSetting = () => import('@/pages/app/OrderSystemSetting/OrderSystemSettingDetail.vue');
const RentalSystemSetting = () => import('@/pages/app/RentalSystemSetting/content/Detail.vue');
const PlanningSystemSetting = () => import('@/pages/app/PlanningSystemSetting/content/Detail.vue');
const ObjectMISystemSetting = () => import('@/pages/app/ObjectMISystemSetting/content/Detail.vue');
const ContractIndexes = () => import('@/pages/components/ContractIndexes.vue');
const StockMutationSystemSetting = () => import('@/pages/app/StockMutationSystemSetting/content/Detail.vue');
const R2mSystemSetting = () => import('@/pages/app/R2MSystemSettings/content/Detail.vue');
const LocationSystemSetting = () => import('@/pages/app/LocationSystemSetting/content/Detail.vue');
const PackListAutoResponderSettings = () => import('@/pages/components/PackListAutoResponderSettings.vue');
const ReturnListAutoResponderSettings = () => import('@/pages/components/ReturnListAutoResponderSettings.vue');
const MIWorkFlowSettings = () => import('@/pages/components/MIWorkFlowSettings.vue');
const OrderAutoResponderSettings = () => import('@/pages/components/OrderAutoResponderSettings.vue');
const TransportMethods = () => import('@/pages/components/TransportMethods.vue');
const SSOMigration = () => import('@/pages/components/SSOMigration.vue');
const ObjectDetail = () => import('@/pages/components/ObjectDetail.vue');
const ObjectInfo = () => import('@/pages/components/ObjectInfo.vue');
const LocationStatuses = () => import('@/pages/components/LocationStatuses.vue');
const ProductStatuses = () => import('@/pages/components/ProductStatuses.vue');
const PersonStatuses = () => import('@/pages/components/PersonStatuses.vue');
const ProjectStatuses = () => import('@/pages/components/ProjectStatuses.vue');
const DistributionBoardSetting = () => import('@/pages/app/MeasurementSheetSystemSetting/content/Detail.vue');
const RelationStatuses = () => import('@/pages/components/RelationStatuses.vue');
const DistributionBoardsFrontOffice = () => import('@/pages/components/FrontOffice/DistributionBoardsFO.vue');
const ObjectStatuses = () => import('@/pages/components/ObjectStatuses.vue');
const ContractStatuses = () => import('@/pages/components/ContractStatuses.vue');
const Depreciations = () => import('@/pages/components/Depreciations.vue');
const Stocks = () => import('@/pages/components/Stocks.vue');
const DocumentKinds = () => import('@/pages/components/DocumentKinds.vue');
const ManageMovePos = () => import('@/pages/components/ManageMovePos.vue');
const MovePos = () => import('@/pages/components/MovePos.vue');
const LocationDetail = () => import('@/pages/components/LocationDetail.vue');
const ProductRealizations = () => import('@/pages/components/ProductRealizations.vue');
const R2M = () => import('@/pages/app/R2M/R2M.vue');
const ProcessedOrderBaskets = () => import('@/pages/components/ProcessedOrderBaskets.vue');
const R2mmovements = () => import('@/pages/components/R2mmovements.vue');
const R2mReceivers = () => import('@/pages/components/R2mReceivers.vue');
const IoTSystemSetting = () => import('@/pages/app/IoTSystemSetting/Detail.vue');
const Automations = () => import('@/pages/components/Automations.vue');
const MeasuringDeviceBrands = () => import('@/pages/components/MeasuringDeviceBrands.vue');
const UserManagement = () => import('@/pages/app/SystemTasks/content/UserSystemSettingsDetail.vue');
const ProjectAutoResponderSettings = () => import('@/pages/components/ProjectAutoResponderSettings.vue');
const PassWordRecovery = () => import('@/pages/components/PasswordRecovery.vue');
const MobileSystemSetting = () => import('@/pages/app/MobileSystemSetting/content/Detail.vue');
const UpdateRoutine = () => import('@/pages/app/SystemTasks/content/UpdateRoutineDetail.vue');
const HourKinds = () => import('@/pages/components/Hourkinds.vue');
const PropertyGroups = () => import('@/pages/components/PropertyGroups.vue');
const WorkShops = () => import('@/pages/components/WorkShops.vue');
const RentalRateCodes = () => import('@/pages/components/RentalRateCodes.vue');
const ObjectAlertSystemSetting = () => import('@/pages/app/ObjectAlertSystemSetting/content/Detail.vue');
const ObjectAlertEmails = () => import('@/pages/components/ObjectAlertEmails.vue');
const StockIndications = () => import('@/pages/components/StockIndications.vue');
const ArticleUnits = () => import('@/pages/components/ArticleUnits.vue');
const ArticleCategories = () => import('@/pages/app/ArticleCategories/App.vue');
const WebMenuItems = () => import('@/pages/app/WebMenuItem/App.vue');
const ContentLanguages = () => import('@/pages/components/ContentLanguages.vue');
const CrossLinkTypes = () => import('@/pages/components/CrossLinkTypes.vue');
const ObjectIDGenerators = () => import('@/pages/components/ObjectIDGenerators.vue');
const ProductCatalog = () => import('@/pages/app/ProductCatalog/App.vue');
const WebPages = () => import('@/pages/components/WebPages.vue');
const ObjectGroups = () => import('@/pages/components/ObjectGroups.vue');
const Conditions = () => import('@/pages/components/Conditions.vue');
const LockReasons = () => import('@/pages/components/LockReasons.vue');
const TimeSchedules = () => import('@/pages/components/TimeSchedules.vue');
const LocationIDGenerators = () => import('@/pages/components/LocationIDGenerators.vue');
const Competences = () => import('@/pages/components/Competences.vue');
const DocumentImports = () => import('@/pages/components/DocumentImports.vue');
const Documents = () => import('@/pages/app/Documents/Documents.vue');
const ProductDocuments = () => import('@/pages/app/Documents/ProductDocuments.vue');
const ObjectDocuments = () => import('@/pages/app/Documents/ObjectDocuments.vue');
const Translations = () => import('@/pages/app/Translations/App.vue');
const TranslationDashboard = () => import('@/pages/app/Translations/Dashboard.vue');
const AddressGroups = () => import('@/pages/components/AddressGroups.vue');
const CompareProducts = () => import('@/pages/app/ProductCatalog/Compare.vue');
const WebPageDetail = () => import('@/pages/components/WebPageDetail.vue');
const BlockReasons = () => import('@/pages/components/BlockReasons.vue');
const Languages = () => import('@/pages/components/Languages.vue');
const SystemSecurityGroups = () => import('@/pages/components/SystemSecurityGroups.vue');
const PaymentMethods = () => import('@/pages/components/PaymentMethods.vue');
const PaymentConditions = () => import('@/pages/components/PaymentConditions.vue');
const RelationGroups = () => import('@/pages/components/RelationGroups.vue');
const WorkFlowStatuses = () => import('@/pages/components/WorkFlowStatuses.vue');
const WorkingTicketStatuses = () => import('@/pages/components/WorkingTicketStatuses.vue');
const WorkFlowEscalationLevels = () => import('@/pages/components/WorkFlowEscalationLevels.vue');
const RelationDetail = () => import('@/pages/components/RelationDetail.vue');
const SchedulerMonitors = () => import('@/pages/components/SchedulerMonitors.vue');
const SchedulerMonitor = () => import('@/pages/components/SchedulerMonitor.vue');
const WorkFlowCategories = () => import('@/pages/components/WorkFlowCategories.vue');
const PlanBlocks = () => import('@/pages/components/PlanBlocks.vue');
const SecuritySystemSetting = () => import('@/pages/app/SystemTasks/content/SecuritySystemSettingDetail.vue');
const Regions = () => import('@/pages/components/Regions.vue');
const EnvironmentSetting = () => import('@/pages/app/SystemSetting/content/EnvironmentSettingsDetail.vue');
const NewUserRequestDetail = () => import('@/pages/components/NewUserRequestDetail.vue');
const NewUserRequests = () => import('@/pages/components/NewUserRequests.vue');
const ActivateUserDetail = () => import('@/pages/components/ActivateUserDetail.vue');
const Imports = () => import('@/pages/components/Imports.vue');
const ProjectTypes = () => import('@/pages/components/ProjectTypes.vue');
const LocationToRental = () => import('@/pages/app/SystemTasks/content/LocationToRentalDetail.vue');
const MeasuringDeviceSystemSetting = () => import('@/pages/app/MeasuringDeviceSystemSetting/Detail.vue');
const MeasuringDeviceFileDocuments = () => import('@/pages/components/MeasuringDeviceFileDocuments.vue');
const Titles = () => import('@/pages/components/Titles.vue');
const ScheduledReports = () => import('@/pages/components/ScheduledReports.vue');
const ScheduledSQLTasks = () => import('@/pages/components/ScheduledSQLTasks.vue');
const QuestionGroups = () => import('@/pages/components/QuestionGroups.vue');
const LocationProperties = () => import('@/pages/components/LocationProperties.vue');
const StockMutationTypes = () => import('@/pages/components/StockMutationTypes.vue');
const MIPriorities = () => import('@/pages/components/MIPriorities.vue');
const QuestionCategories = () => import('@/pages/components/QuestionCategories.vue');
const FieldClientMessageCodes = () => import('@/pages/components/FieldClientMessageCodes.vue');
const TeamRoles = () => import('@/pages/components/TeamRoles.vue');
const WorkHourPlans = () => import('@/pages/components/WorkHourPlans.vue');
const WorkFlowSubGroupFormalDescriptions = () => import('@/pages/components/WorkFlowSubGroupFormalDescriptions.vue');
const MediaTypes = () => import('@/pages/components/MediaTypes.vue');
const AbsenceKinds = () => import('@/pages/components/AbsenceKinds.vue');
const HourRegistrations = () => import('@/pages/components/Hourregistrations.vue');
const ReturnEntryDetail = () => import('@/pages/components/ReturnEntryDetail.vue');
const ReturnLists = () => import('@/pages/components/ReturnLists.vue');
const WarehouseDetail = () => import('@/pages/components/WarehouseDetail.vue');
const HoursPerWeek = () => import('@/pages/components/HoursPerWeek/HoursPerWeek.vue');
const TrustedSources = () => import('@/pages/components/TrustedSources.vue');
const ObjectAutoResponderSettings = () => import('@/pages/components/ObjectAutoResponderSettings.vue');
const ReturnListItems = () => import('@/pages/components/ReturnListItems.vue');
const EventMails = () => import('@/pages/components/EventMails.vue');
const CheckLists = () => import('@/pages/components/CheckLists.vue');
const OverhaulOrderTemplates = () => import('@/pages/components/OverhaulOrderTemplates.vue');
const WebhookMessages = () => import('@/pages/components/WebhookMessages.vue');
const OverhaulOrders = () => import('@/pages/components/OverhaulOrders.vue');

const TEST_PATH = 'backoffice/PurchaseOrderLines';

// NOTE: backoffice routes in /backoffice/app.aspx connect to these routenames

const routes = [{
  path: '/backoffice/scheduler',
  name: 'scheduler',
  component: Scheduler
},
{
  path: '/backoffice/workingtickets',
  name: 'workingtickets',
  component: WorkingTickets
},
{
  path: '/mybaskets',
  name: 'mybaskets',
  component: MyBaskets
},
{
  path: '/movebaskets',
  name: 'movebaskets',
  component: MoveBaskets
},
{
  path: '/orderbaskets',
  name: 'orderbaskets',
  component: OrderBaskets
},
{
  path: '/backoffice/einvoices',
  name: 'einvoices',
  component: EInvoices
},
{
  path: '/objectlocationmischedules',
  name: 'objectlocationmischedules',
  component: ObjectLocationMISchedules
},
{
  path: '/objects',
  name: 'objects',
  component: Objects
},
{
  path: '/objectlocations',
  name: 'objectlocations',
  component: ObjectLocations
},
{
  path: '/objectmis',
  name: 'objectmis',
  component: ObjectMIs
},
{
  path: '/admin/systemtables/objectcodes',
  name: 'objectcodes',
  component: ObjectCodes
},
{
  path: '/backoffice/orders',
  name: 'orders',
  component: Orders
},
{
  path: '/backoffice/workflows',
  name: 'workflows',
  component: WorkFlowViews
},
{
  path: '/processedmovebaskets',
  name: 'processedmovebaskets',
  component: ProcessedMoveBaskets
},
{
  path: '/backoffice/picklists',
  name: 'picklists',
  component: PickLists
},
{
  path: '/backoffice/packlists',
  name: 'packlists',
  component: PackLists,
  meta: {
    hasSettings: true
  }
},
{
  path: '/backoffice/persons',
  name: 'persons',
  component: Persons
},
{
  path: '/backoffice/projects',
  name: 'projects',
  component: Projects
},
{
  path: '/relations',
  name: 'relations',
  component: Relations
},
{
  path: '/mis',
  name: 'mis',
  component: MIs
},
{
  path: '/locations',
  name: 'locations',
  component: Locations
},
{
  path: '/backoffice/products',
  name: 'products',
  component: Products
},
{
  path: '/invoices',
  name: 'invoices',
  component: Invoices
},
{
  path: '/objecttypes',
  name: 'objecttypes',
  component: ObjectTypes
},
{
  path: '/membershiprequest/:requestid',
  name: 'membershiprequest',
  component: ProvisioningPage,
  meta: { linkText: 'Membershiprequest' }
},
{
  path: '/backoffice/returnentries',
  name: 'returnentries',
  component: ReturnEntry
},
{
  path: '/object00locations',
  name: 'object00locations',
  component: Object00Locations
},
{
  path: '/objectlocationlog',
  name: 'objectlocationlog',
  component: ObjectLocationLog
},
{
  path: '/admin/systemtasks/sessionuserlogs',
  name: 'sessionuserlogs',
  component: SessionUserLogs
},
{
  path: '/backoffice/orderlines',
  name: 'orderlines',
  component: OrderLines
},
{
  path: '/admin/systemtables/teams',
  name: 'teams',
  component: Teams
},
{
  path: '/backoffice/invoicelines',
  name: 'invoicelines',
  component: InvoiceLines
},
{
  path: '/backoffice/purchaseorderlines',
  name: 'purchaseorderlines',
  component: PurchaseOrderLines
},
{
  path: '/admin/systemtables/budgetcodes',
  name: 'budgetcodes',
  component: BudgetCodes
},
{
  path: '/backoffice/warehouses',
  name: 'warehouses',
  component: Warehouses
},
{
  path: '/admin/systemtasks/users',
  name: 'users',
  component: Users
},
{
  path: '/admin/systemtasks/IdentityProviders',
  name: 'identityproviders',
  component: IdentityProviders
},
{
  path: '/contracts',
  name: 'contracts',
  component: Contracts
},
{
  path: '/backoffice/purchaseorders',
  name: 'purchaseorders',
  component: PurchaseOrders
},
{
  path: '/backoffice/returnentrylines',
  name: 'returnentrylines',
  component: ReturnEntryLines
},
{
  path: '/admin/systemtables/objectmiautorespondersettings',
  name: 'objectmiautorespondersettings',
  component: ObjectMIAutoResponderSettings
},
{
  path: '/admin/systemtables/personuserautorespondersettings',
  name: 'personuserautorespondersettings',
  component: PersonUserAutoResponderSettings
},
{
  path: '/backoffice/objectproperties',
  name: 'objectproperties',
  component: ObjectObjectProperties
},
{
  path: '/admin/systemsettings/purchaseordersystemsetting',
  name: 'purchaseordersystemsetting',
  component: PurchaseOrderSystemSetting
},
{
  path: '/admin/systemtables/ordertemplates',
  name: 'ordertemplates',
  component: OrderTemplates
},
{
  path: '/downloadrequests',
  name: 'downloadrequests',
  component: DownloadRequests
},
{
  path: '/admin/systemtables/locationtypes',
  name: 'locationtypes',
  component: LocationTypes
},
{
  path: '/admin/systemtables/reportdefinitions',
  name: 'reportdefinitions',
  component: ReportDefinitions
},
{
  path: '/licenses',
  name: 'license',
  component: License
},
{
  path: '/admin/systemtasks/apiclients',
  name: 'apiclients',
  component: ApiClients
},
{
  path: '/admin/systemtables/miplans',
  name: 'miplans',
  component: MIPlans
},
{
  path: '/admin/systemsettings/systemsetting',
  name: 'systemsetting',
  component: SystemSetting
},
{
  path: '/admin/systemsettings/financialsystemsetting',
  name: 'financialsystemsetting',
  component: SystemFinancialSetting
},
{
  path: '/admin/systemsettings/contractsystemsetting',
  name: 'contractsystemsetting',
  component: ContractSystemSetting
},
{
  path: '/admin/systemsettings/mobilemessagesystemsetting',
  name: 'mobilemessagesystemsetting',
  component: FieldClientMessageSystemSetting
},
{
  path: '/backoffice/mobilemessages',
  name: 'mobilemessages',
  component: MobileMessages
},
{
  path: '/admin/systemtables/movebasketautorespondersettings',
  name: 'movebasketautorespondersettings',
  component: MoveBasketAutoResponderSettings
},
{
  path: '/admin/systemtasks/mailserversettings',
  name: 'mailserversettings',
  component: MailServerSetting
},
{
  path: '/admin/systemtasks/databasesettings',
  name: 'databasesettings',
  component: DatabaseSetting
},
{
  path: '/admin/systemtasks/recalculateworkflowpositions',
  name: 'recalculateworkflowpositions',
  component: RecalculateWorkflowPosition
},
{
  path: '/admin/systemtables/workabledays',
  name: 'workabledays',
  component: WorkableDays
},
{
  path: '/admin/systemtables/pricelists',
  name: 'pricelists',
  component: PriceLists
},
{
  path: '/backoffice/journals',
  name: 'journals',
  component: Journals
},
{
  path: '/admin/systemtables/administrations',
  name: 'administrations',
  component: Administrations
},
{
  path: '/admin/systemtables/contracttypes',
  name: 'contracttypes',
  component: ContractTypes
},
{
  path: '/admin/systemtables/contractautorespondersettings',
  name: 'contractautorespondersettings',
  component: ContractAutoResponderSettings
},
{
  path: '/admin/systemtables/newuserrequestautorespondersettings',
  name: 'newuserrequestautorespondersettings',
  component: NewUserRequestAutoResponseSettings
},
{
  path: '/admin/systemtables/purchaseorderautorespondersettings',
  name: 'purchaseorderautorespondersettings',
  component: PurchaseOrderAutoResponseSettings
},
{
  path: '/admin/systemtables/invoiceautorespondersettings',
  name: 'invoiceautorespondersettings',
  component: InvoiceAutoResponseSettings
},
{
  path: '/admin/systemtables/purchaseinvoiceautorespondersettings',
  name: 'purchaseinvoiceautorespondersettings',
  component: PurchaseInvoiceAutoResponseSettings
},
{
  path: '/admin/systemtables/fixedassetgroups',
  name: 'fixedassetgroups',
  component: FixedAssetGroups
},
{
  path: '/admin/backoffice/purchaseinvoices',
  name: 'purchaseinvoices',
  component: PurchaseInvoices
},
{
  path: '/admin/systemtables/bookyears',
  name: 'bookyears',
  component: BookYears
},
{
  path: '/admin/systemtables/ordercosts',
  name: 'ordercosts',
  component: RegionOrderCosts
},
{
  path: '/admin/systemtables/transportcosts',
  name: 'transportcosts',
  component: RegionTransportCosts
},
{
  path: '/backoffice/productstockpurchase',
  name: 'productstockpurchase',
  component: ProductStockPurchase
},
{
  path: '/admin/systemsettings/objectsystemsetting',
  name: 'objectsystemsetting',
  component: ObjectSystemSetting
},
{
  path: '/backoffice/recurringworkflows',
  name: 'recurringworkflows',
  component: RecurringWorkFlow
},
{
  path: '/backoffice/workflowtemplates',
  name: 'workflowtemplates',
  component: WorkflowTemplates
},
{
  path: '/admin/systemtables/locationautorespondersettings',
  name: 'locationautorespondersettings',
  component: LocationAutoResponderSettings
},
{
  path: '/locationstatuslogs',
  name: 'locationstatuslogs',
  component: LocationStatusLogs
},
{
  path: '/admin/systemtables/workingticketautorespondersettings',
  name: 'workingticketautorespondersettings',
  component: WorkingTicketAutoResponderSettings
},
{
  path: '/backoffice/capacityplanning',
  name: 'capacityplanning',
  component: CapacityPlanning
},
{
  path: '/admin/systemtables/emailtemplates',
  name: 'emailtemplates',
  component: EmailTemplates
},
{
  path: '/backoffice/stockrevaluations',
  name: 'stockrevaluations',
  component: StockRevaluations
},
{
  path: '/backoffice/competences',
  // name: 'competences',
	name: 'backoffice_competences',
  component: PersonCompetences
},
{
  path: '/objectmeterschedules',
  name: 'objectmeterschedules',
  component: ObjectMeterSchedules
},
{
  path: '/admin/systemtables/meterreadings',
  name: 'meterreadings',
  component: Meterreadings
},
{
  path: '/admin/systemtables/workflowgroups',
  name: 'workflowgroups',
  component: WorkFlowGroups
},
{
  path: '/admin/systemtables/countries',
  name: 'countries',
  component: Countries
},
{
  path: '/admin/systemtables/lists',
  name: 'lists',
  component: Lists
},
{
  path: '/admin/systemtables/workflowautorespondersettings',
  name: 'workflowautorespondersettings',
  component: WorkFlowAutoResponderSettings
},
{
  path: '/admin/systemtables/formconfigurations',
  name: 'formconfigurations',
  component: FormConfigurations
},
{
  path: '/admin/systemtables/brands',
  name: 'brands',
  component: Brands
},
{
  path: '/admin/systemtables/quantities',
  name: 'quantities',
  component: Quantities
},
{
  path: '/admin/systemtables/inspectionnorms',
  name: 'inspectionnorms',
  component: InspectionNorms
},
{
  path: '/admin/systemtables/vatcodes',
  name: 'vatcodes',
  component: VatCodes
},
{
  path: '/frontoffice/product',
  name: 'product',
  component: ProductDetail
},
{
  path: '/admin/systemtables/reasons',
  name: 'reasons',
  component: Reasons
},
{
  path: '/admin/systemtables/returnrequestautorespondersettings',
  name: 'returnrequestautorespondersettings',
  component: ReturnRequestAutoResponderSettings
},
{
  path: '/admin/systemtables/workflowservicelevels',
  name: 'workflowservicelevels',
  component: WorkFlowServiceLevels
},
{
  path: '/frontoffice/form',
  name: 'form',
  component: FormDetail
},
{
  path: '/backoffice/returnrequests',
  name: 'returnrequests',
  component: ReturnRequests
},
{
  path: '/admin/systemtasks/logsettings',
  name: 'logsettings',
  component: LogSettings
},
{
  path: '/admin/systemtasks/versions',
  name: 'versions',
  component: Versions
},
{
  path: '/admin/systemtasks/logs',
  name: 'logs',
  component: Logs
},
{
  path: '/admin/systemtables/workflowpriorities',
  name: 'workflowpriorities',
  component: WorkFlowPriorities
},
{
  path: '/frontoffice/returnrequests',
  name: 'returnrequest_frontoffice',
  component: ReturnRequestsFrontOffice
},
{
  path: '/admin/systemsettings/productsystemsetting',
  name: 'productsystemsetting',
  component: ProductSystemSetting
},
{
  path: '/frontoffice/basket',
  name: 'basket',
  component: BasketDetail
},
{
  path: '/backoffice/orderbasket',
  name: 'orderbasket',
  component: OrderBasketDetail
},
{
  path: '/frontoffice/movebasket',
  name: 'movebasket',
  component: MoveBasketDetail
},
{
  path: '/admin/systemsettings/ordersystemsetting',
  name: 'ordersystemsetting',
  component: OrderSystemSetting
},
{
  path: '/admin/systemsettings/rentalsystemsetting',
  name: 'rentalsystemsetting',
  component: RentalSystemSetting
},
{
  path: '/admin/systemsettings/planningsystemsetting',
  name: 'planningsystemsetting',
  component: PlanningSystemSetting
},
{
  path: '/admin/systemsettings/objectmisystemsetting',
  name: 'objectmisystemsetting',
  component: ObjectMISystemSetting
},
{
  path: '/admin/systemtables/contractindexes',
  name: 'contractindexes',
  component: ContractIndexes
},
{
  path: '/admin/systemsettings/stockmutationsystemsetting',
  name: 'stockmutationsystemsetting',
  component: StockMutationSystemSetting
},
{
  path: '/admin/systemsettings/r2msystemsetting',
  name: 'r2msystemsetting',
  component: R2mSystemSetting
},
{
  path: '/admin/systemsettings/locationsystemsetting',
  name: 'locationsystemsetting',
  component: LocationSystemSetting
},
{
  path: '/admin/systemtables/packlistautorespondersettings',
  name: 'packlistautorespondersettings',
  component: PackListAutoResponderSettings
},
{
  path: '/admin/systemtables/returnlistautorespondersettings',
  name: 'returnlistautorespondersettings',
  component: ReturnListAutoResponderSettings
},
{
  path: '/admin/systemtables/miworkflowsettings',
  name: 'miworkflowsettings',
  component: MIWorkFlowSettings
},
{
  path: '/admin/systemtables/orderautorespondersettings',
  name: 'orderautorespondersettings',
  component: OrderAutoResponderSettings
},
{
  path: '/frontoffice/object',
  name: 'object',
  component: ObjectDetail
},
{
  path: '/frontoffice/objectinfo',
  name: 'objectinfo',
  component: ObjectInfo
},
{
  path: '/admin/systemtables/locationstatuses',
  name: 'locationstatuses',
  component: LocationStatuses
},
{
  path: '/admin/systemtables/productstatuses',
  name: 'productstatuses',
  component: ProductStatuses
},
{
  path: '/migrateWizard',
  name: 'migrateWizard',
  component: SSOMigration
},
{
  path: '/admin/systemsettings/distributionboardsetting',
  name: 'distributionboardsetting',
  component: DistributionBoardSetting
},
{
  path: '/admin/systemtables/relationstatuses',
  name: 'relationstatuses',
  component: RelationStatuses
},
{
  path: '/admin/systemtables/transportmethods',
  name: 'transportmethods',
  component: TransportMethods
},
{
  path: '/admin/systemtables/personstatuses',
  name: 'personstatuses',
  component: PersonStatuses
},
{
  path: '/admin/systemtables/projectstatuses',
  name: 'projectstatuses',
  component: ProjectStatuses
},
{
  path: '/frontoffice/distributionboards',
  name: 'distributionboards_frontoffice',
  component: DistributionBoardsFrontOffice
},
{
  path: '/admin/systemtables/objectstatuses',
  name: 'objectstatuses',
  component: ObjectStatuses
},
{
  path: '/admin/systemtables/contractstatuses',
  name: 'contractstatuses',
  component: ContractStatuses
},
{
  path: '/backoffice/depreciations',
  name: 'depreciations',
  component: Depreciations
},
{
  path: '/backoffice/stocks',
  name: 'stocks',
  component: Stocks
},
{
  path: '/admin/systemtables/documentkinds',
  name: 'documentkinds',
  component: DocumentKinds
},
{
  path: '/admin/systemtables/managemovepos',
  name: 'managemovepos',
  component: ManageMovePos
},
{
  path: '/backoffice/movepos',
  name: 'movepos',
  component: MovePos
},
{
  path: '/frontoffice/location',
  name: 'location',
  component: LocationDetail
},
{
  path: '/admin/systemtables/productrealizations',
  name: 'productrealizations',
  component: ProductRealizations
},
{
  path: '/backoffice/processedorderbaskets',
  name: 'processedorderbaskets',
  component: ProcessedOrderBaskets
},
{
  path: '/backoffice/r2m',
  name: 'r2m',
  component: R2M,
},
{
  path: '/backoffice/r2mmovements',
  name: 'r2mmovements',
  component: R2mmovements
},
{
  path: '/backoffice/r2mreceivers',
  name: 'r2mreceivers',
  component: R2mReceivers
},
{
  path: '/admin/systemsettings/iotsystemsetting',
  name: 'iotsystemsetting',
  component: IoTSystemSetting
},
{
  path: '/backoffice/automations',
  name: 'automations',
  component: Automations
},
{
  path: '/admin/systemtables/measuringdevicebrands',
  name: 'measuringdevicebrands',
  component: MeasuringDeviceBrands
},
{
  path: '/admin/systemtasks/usermanagement',
  name: 'usermanagement',
  component: UserManagement
},
{
  path: '/admin/systemtables/projectautorespondersettings',
  name: 'projectautorespondersettings',
  component: ProjectAutoResponderSettings
},
{
  path: '/passwordrecovery',
  name: 'passwordrecovery',
  component: PassWordRecovery
},
{
  path: '/admin/systemsettings/mobilesystemsetting',
  name: 'mobilesystemsetting',
  component: MobileSystemSetting
},
{
  path: '/admin/systemtasks/updateroutine',
  name: 'updateroutine',
  component: UpdateRoutine
},
{
  path: '/admin/systemtables/hourkinds',
  name: 'hourkinds',
  component: HourKinds
}, 
{
  path: '/admin/systemtables/propertygroups',
  name: 'propertygroups',
  component: PropertyGroups
},
{
  path: '/admin/systemtables/costcodes',
  name: 'costcodes',
  component: AdminSystemTables.CostCode
}, 
{
  path: '/admin/systemtables/costcategories',
  name: 'costcategories',
  component: AdminSystemTables.CostCategory
},
{
  path: '/admin/systemtables/productgroups',
  name: 'productgroups',
  component: AdminSystemTables.ArticleGroup
},
{
  path: '/admin/systemtables/hscodes',
  name: 'hscodes',
  component: AdminSystemTables.HSCode
},
{
  path: '/admin/systemtables/workshops',
  name: 'workshops',
  component: WorkShops
},
{
  path: '/admin/systemtables/rentalratecodes',
  name: 'rentalratecodes',
  component: RentalRateCodes
},
{
  path: '/admin/systemsettings/objectalertsystemsetting',
  name: 'objectalertsystemsetting',
  component: ObjectAlertSystemSetting
},
{
  path: '/backoffice/objectalertemails',
  name: 'objectalertemails',
  component: ObjectAlertEmails
},
{
  path: '/admin/systemsettings/stockindications',
  name: 'stockindications',
  component: StockIndications
},
{
  path: '/admin/systemsettings/productunits',
  name: 'productunits',
  component: ArticleUnits
},
{
  path: '/admin/systemtables/productproductlines',
  name: 'productproductlines',
  component: AdminSystemTables.ArticleProductLine
},
{
  path: '/admin/systemtables/productcategories',
  name: 'productcategories',
  component: ArticleCategories
},
{
  path: '/admin/systemtables/contentlanguages',
  name: 'contentlanguages',
  component: ContentLanguages
},
{
  path: '/admin/webmenu',
  name: 'webmenu',
  component: WebMenuItems
},
{
  path: '/admin/systemtables/crosslinktypes',
  name: 'crosslinktypes',
  component: CrossLinkTypes
},
{
    path: '/admin/systemtables/objectidgenerators',
    name: 'objectidgenerators',
    component: ObjectIDGenerators
},
{
  path: '/frontoffice/productcatalog',
  name: 'productcatalog',
  component: ProductCatalog
},
{
	path: '/admin/webpages',
	name: 'webpages',
	component: WebPages
},
{
  path: '/admin/systemtables/objectgroups',
  name: 'objectgroups',
  component: ObjectGroups
},
{
  path: '/admin/systemtables/conditions',
  name: 'conditions',
  component: Conditions
},
{
  path: '/admin/systemtables/lockreasons',
  name: 'lockreasons',
  component: LockReasons
},
{
  path: '/admin/systemtables/timeschedules',
  name: 'timeschedules',
  component: TimeSchedules
},
{
  path: '/admin/systemtables/locationgroups',
  name: 'locationgroups',
  component: AdminSystemTables.LocationGroup
},
{
    path: '/admin/systemtables/locationidgenerators',
    name: 'locationidgenerators',
    component: LocationIDGenerators
},
{
    path: '/admin/systemtables/competences',
    name: 'competences',
    component: Competences
},
{
  path: '/admin/systemtables/competencetypes',
  name: 'competencetypes',
  component: AdminSystemTables.RequirementType
}, 
{
  path: '/backoffice/documents',
  name: 'documents',
  component: Documents
}, 
{
  path: '/backoffice/productdocuments',
  name: 'productdocuments',
  component: ProductDocuments
}, 
{
  path: '/backoffice/objectdocuments',
  name: 'objectdocuments',
  component: ObjectDocuments
}, 
{
  path: '/backoffice/documentimports',
  name: 'documentimports',
  component: DocumentImports
},
{
  path: '/admin/systemtasks/translations',
  name: 'translations',
  component: Translations
},
{
  path: '/admin/systemtasks/translationdashboard',
  name: 'translationdashboard',
  component: TranslationDashboard
},
{
  path: '/admin/systemtables/addressgroups',
  name: 'addressgroups',
  component: AddressGroups
},
{
  path: '/frontoffice/compareproducts',
  name: 'compareproducts',
  component: CompareProducts
},
{
  path: '/frontoffice/webpage',
  name: 'webpage',
  component: WebPageDetail
},
{
  path: '/admin/systemtables/blockreasons',
  name: 'blockreasons',
  component: BlockReasons
},
{
  path: '/admin/systemtables/languages',
  name: 'languages',
  component: Languages
},
{
  path: '/admin/systemtasks/securitygroups',
  name: 'securitygroups',
  component: SystemSecurityGroups
},
{
  path: '/admin/systemtasks/paymentmethods',
  name: 'paymentmethods',
  component: PaymentMethods
},
{
  path: '/admin/systemtables/paymentconditions',
  name: 'paymentconditions',
  component: PaymentConditions
},
{
  path: '/admin/systemtables/relationgroups',
  name: 'relationgroups',
  component: RelationGroups
},
{
  path: '/admin/systemtables/workflowstatuses',
  name: 'workflowstatuses',
  component: WorkFlowStatuses
},
{
  path: '/admin/systemtables/workingticketstatuses',
  name: 'workingticketstatuses',
  component: WorkingTicketStatuses
},
{
  path: '/admin/systemtables/workflowescalationlevels',
  name: 'workflowescalationlevels',
  component: WorkFlowEscalationLevels
},
{
  path: '/frontoffice/relation',
  name: 'relation',
  component: RelationDetail
},
{
  path: '/monitor',
  name: 'monitor',
  component: SchedulerMonitor
},
{
  path: '/admin/systemtables/schedulermonitors',
  name: 'schedulermonitors',
  component: SchedulerMonitors
},
{
  path: '/admin/systemtables/workflowcategories',
  name: 'workflowcategories',
  component: WorkFlowCategories
},
{
  path: '/admin/systemtables/planblocks',
  name: 'planblocks',
  component: PlanBlocks
},
{
  path: '/admin/systemtasks/securitysystemsetting',
  name: 'securitysystemsetting',
  component: SecuritySystemSetting
},
{
  path: '/admin/systemtables/regions',
  name: 'regions',
  component: Regions
},
{
  path: '/admin/systemtasks/environmentsettings',
  name: 'environmentsettings',
  component: EnvironmentSetting
},
{
  path: '/register',
  name: 'newuserrequest',
  component: NewUserRequestDetail
},
{
  path: '/newuserregistrations',
  name: 'newuserregistrations',
  component: NewUserRequests
},
{
  path: '/useractivation',
  name: 'useractivation',
  component: ActivateUserDetail
},
{
  path: '/backoffice/importtasks',
  name: 'imports',
  component: Imports
},
{
  path: '/admin/systemtables/projecttypes',
  name: 'projecttypes',
  component: ProjectTypes
},
{
  path: '/admin/systemtables/currencies',
  name: 'currencies',
  component: AdminSystemTables.Currency
},
{
  path: '/admin/systemtables/generalledgers',
  name: 'generalledgers',
  component: AdminSystemTables.GeneralLedger
}, 
{
  path: '/admin/systemtasks/locationtorental',
  name: 'locationtorental',
  component: LocationToRental
},
{
  path: '/admin/systemsettings/measuringdevicesystemsetting',
  name: 'measuringdevicesystemsetting',
  component: MeasuringDeviceSystemSetting
},
{
  path: '/frontoffice/measurementfiles',
  name: 'measurementfiles',
  component: MeasuringDeviceFileDocuments
},
{
  path: '/admin/systemtables/titles',
  name: 'titles',
  component: Titles
},
{
  path: '/admin/systemtasks/scheduledreports',
  name: 'scheduledreports',
  component: ScheduledReports
},
{
  path: '/admin/systemtasks/scheduledsqltasks',
  name: 'scheduledsqltasks',
  component: ScheduledSQLTasks
},
{
  path: '/admin/systemtables/questiongroups',
  name: 'questiongroups',
  component: QuestionGroups
}, 
{
  path: '/admin/systemtables/stockmutationtypes',
  name: 'stockmutationtypes',
  component: StockMutationTypes
}, 
{
  path: '/frontoffice/locationproperties',
  name: 'locationproperties',
  component: LocationProperties
}, 
{
  path: '/admin/systemtables/mipriorities',
  name: 'mipriorities',
  component: MIPriorities
}, 
{
  path: '/admin/systemtables/questioncategories',
  name: 'questioncategories',
  component: QuestionCategories
}, 
{
  path: '/admin/systemtables/fieldclientmessagecodes',
  name: 'fieldclientmessagecodes',
  component: FieldClientMessageCodes
}, 
{
  path: '/admin/systemtables/teamroles',
  name: 'teamroles',
  component: TeamRoles
},
{
  path: '/admin/systemtables/workhourplans',
  name: 'workhourplans',
  component: WorkHourPlans
},
{
  path: '/admin/systemtables/workflowsubgroupformaldescriptions',
  name: 'workflowsubgroupformaldescriptions',
  component: WorkFlowSubGroupFormalDescriptions
},
{
  path: '/admin/systemtables/mediatypes',
  name: 'mediatypes',
  component: MediaTypes
},
{
  path: '/admin/systemtables/absencekinds',
  name: 'absencekinds',
  component: AbsenceKinds
},
{
  path: '/backoffice/hourregistrations',
  name: 'hourregistrations',
  component: HourRegistrations
},
{
  path: '/backoffice/returnentry',
  name: 'returnentry',
  component: ReturnEntryDetail
},
{
  path: '/backoffice/returnlists',
  name: 'returnlists',
  component: ReturnLists
},
{
  path: '/backoffice/warehouse',
  name: 'warehouse',
  component: WarehouseDetail
},
{
  path: '/backoffice/hoursperweek',
  name: 'hoursperweek',
  component: HoursPerWeek 
},
{
  path: '/admin/systemtasks/trustedsources',
  name: 'trustedsources',
  component: TrustedSources
},
{
  path: '/admin/systemtables/objectautorespondersettings',
  name: 'objectautorespondersettings',
  component: ObjectAutoResponderSettings
},
{
  path: '/backoffice/returnlistitems',
  name: 'returnlistitems',
  component: ReturnListItems
},
{
  path: '/admin/systemtasks/eventlogmails',
  name: 'eventlogmails',
  component: EventMails
},
{
  path: '/admin/systemtables/checklists',
  name: 'checklists',
  component: CheckLists
},
{
  path: '/admin/systemtables/overhaulordertemplates',
  name: 'overhaulordertemplates',
  component: OverhaulOrderTemplates
},
{
  path: '/admin/systemtasks/webhookmessages',
  name: 'webhookmessages',
  component: WebhookMessages
},
{
  path: '/backoffice/overhaulorders',
  name: 'overhaulorders',
  component: OverhaulOrders
}
];
const router = new VueRouter({
  routes,
  mode: 'abstract'
});

router.beforeEach((to, from, next) => {
  if (!to || !to.matched || to.matched.length === 0) {
      console.log("404 route not found");
  }
  loadLanguageAsync(localize.i18n, getLang()).then(() => {
    next();
  });
}); 

const vm = {
  navigate: null,
  setup: function (initialpath = null, initialsettings = null) {
    this.vueInstance = new Vue({
      components: {
        'toaster': Toaster,
        'dialogs': Dialogs
      },
      i18n: localize.i18n,
      router,
      store,
      el: '#app',
      data() {
        return {
          path: TEST_PATH,
          settings: {}
        };
      },
      template: `
      <div>
        <form class="vue-components-wrapper" onsubmit="return false;">
        <router-view v-bind="settings"></router-view>
        <toaster ref="toaster" />
        <dialogs ref="dialogs" />
        <portal-target name="bottomPage" multiple />
        </form>
      </div>`,
      async created () {
        const self = this;
        if (initialpath) {
          self.path = initialpath;
        }
        if (initialsettings) {
          self.settings = initialsettings;
        }
        vm.navigate = self.navigate;
      },
      mounted() {
        const self = this;
        this.$router.push({ name: this.path });
        Vue.use(ToastPlugin, { toaster: self.$refs.toaster, dialogs: self.$refs.dialogs });
        bootstrapHelper(store);
      },
      methods: {
        setConfig(config) {
          this.config = config;
        },
        navigate(path, settings = null) {
          this.$log('path', path, settings);
          this.settings = settings;
          this.$router.push({ name: path });
        }
      },
      computed: {
        baseUri () {
          return this.$baseuri;
        }
      },
      watch: {
        '$route' (to, from) {
          this.$log('route changed', to.meta);
        }
      }
    });
  },
  setPublicPath: function (path) {
    // eslint-disable-next-line
    __webpack_public_path__ = path;
  }
};

export const RouteList = routes;

window.vm = vm;
